// extracted by mini-css-extract-plugin
module.exports = {"w6stj26":"w6stj26"};